export class LocalName {
    static getName(item) {
        if (!localStorage.getItem('lan')) {
            return item?.nameRu;
        }
        if (localStorage.getItem('lan') === "РУС") {
            return item?.nameRu;
        }
        if (localStorage.getItem('lan') === "ҚАЗ") {
            return item?.nameKz;
        }
        if (localStorage.getItem('lan') === "ENG") {
            return item?.nameEng;
        }
        return item?.nameRu;
    }

    static getNameKz(item) {
        return item?.nameKz;
    }

    static getNameRu(item) {
        return item?.nameRu;
    }

    static getNameEng(item) {
        return item?.nameEng;
    }

    static getDescription(item) {
        if (localStorage.getItem('lan') === "РУС") {
            return item?.descriptionRu;
        }
        if (localStorage.getItem('lan') === "ҚАЗ") {
            return item?.descriptionKz;
        }
        if (localStorage.getItem('lan') === "ENG") {
            return item?.descriptionEng;
        }
        return item?.descriptionRu;
    }
}

// const LocalizationText = ({ text }) => {
//     const { i18n } = useTranslation();
//     const currentLocale = i18n.language;
//
//     if (currentLocale === 'kk') {
//         return <span>{text.nameKZ}</span>;
//     } else if (currentLocale === 'ru') {
//         return <span>{text.name}</span>;
//     } else return <></>;
// };
//
// export default LocalizationText;